<template>
  <v-container class="lender-results-container">
    <h1 class="hero-title">Your Lender Results</h1>
    <p class="hero-description">
      Here you can access the information you provided, as well as the recommended lenders.
    </p>

    <Loader v-if="loading" :loading="true" />

    <div v-else class="match-overview-wrapper">
      <template v-if="deals && deals.length">
        <max-deals-notification
          v-if="!canMakeDeals"
          :deals="latestDeals" />

        <user-deals-list
          v-if="deals && deals.length"
          :deals="deals" />
      </template>

      <no-deals v-else />
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import MaxDealsNotification from './MaxDealsNotification'
import NoDeals from './NoDeals'
import UserDealsList from './UserDealsList'

export default {
  name: 'LenderResultsPage',
  components: {
    MaxDealsNotification,
    NoDeals,
    UserDealsList,
  },

  data: () => ({
    canMakeDeals: true,
    latestDeals: [],
    loading: true,
    deals: [],
  }),

  computed: {
    ...mapGetters('feathers', ['apiDeals']),
    ...mapState('authStore', {
      userData: 'userData',
    }),
  },

  async created () {
    this.loading = true

    await this.getDealsData()
    try {
      this.latestDeals = await this.getRecentDeals(this.userData.id)

      this.canMakeDeals = this.latestDeals.length < 3
    } catch (error) {
      this.addAlert({
        type: 'error',
        message: `Could not retrieve recent deal count: ${error.message}`,
      })
    }

    this.loading = false
  },
  methods: {
    ...mapActions('feathers', ['getRecentDeals']),

    async getDealsData () {
      try {
        this.deals = await this.apiDeals.find({
          query: {
            userId: this.userData.id,
            $include: { Matches: true },
          },
        })
      } catch (error) {
        this.addAlert({
          type: 'error',
          message: `Could not retrieve deals: ${error.message}`,
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.lender-results-container {

  h1 {
    color: $primaryBlue;

    margin-bottom: 10px;
    @include lg { margin-bottom: 30px; }
  }

  p {
    color: $textDarkMuted;

    font-size: 18px;
    line-height: 21px;
    letter-spacing: 0;

    margin-bottom: 80px;
    max-width: 700px;
  }
}

.match-overview-wrapper {
  width: 100%;
}

</style>
